import { useMemo } from 'react'
import { getAgentAvatarPrimary, getAgentAvatarSeed, getAgentAvatarWave } from '@/components/Agents/agentAvatarWave'
import styles from './index.module.scss'

export function useAgentProfileAvatarModel({
  size = 24,
  seed,
  agentId,
  name,
  avatarSrc = null,
  avatarAlt = '',
  className = '',
  'aria-hidden': ariaHidden = true,
}) {
  const rootClass = `${styles.avatar}${className ? ` ${className}` : ''}`
  const resolvedSeed = useMemo(() => seed ?? getAgentAvatarSeed(agentId, name), [seed, agentId, name])
  const wave = useMemo(() => getAgentAvatarWave(resolvedSeed, agentId, name), [resolvedSeed, agentId, name])
  const waveStyle = useMemo(() => {
    const siaPrimary = getAgentAvatarPrimary(agentId, name, resolvedSeed)
    return {
      '--agent-wave-primary': siaPrimary ?? 'var(--app-primary, #0078d4)',
      '--agent-wave-b': wave.colorB,
      '--agent-wave-c': wave.colorC,
      '--agent-wave-angle': `${wave.angle}deg`,
      '--agent-wave-duration': `${wave.spinDuration}s`,
    }
  }, [wave, agentId, name, resolvedSeed])

  return { size, avatarSrc, avatarAlt, ariaHidden, rootClass, waveStyle }
}
